import { ChipProps } from '@mui/material';
import {
  ReportGroupSummaryConfidenceLevel,
  ReportGroupSummaryStatus,
  ReportGroupSummaryTimeframeOption,
} from 'src/types/reportGroup';

export const REPORT_GROUP_SUMMARY_MILLISECONDS_IN_DAY = 86400000;

export const REPORT_GROUP_SUMMARY_MIN_MESSAGE_LIMIT = 5;
export const REPORT_GROUP_SUMMARY_MAX_MESSAGE_LIMIT = 1000;
export const REPORT_GROUP_SUMMARY_DEFAULT_MESSAGE_LIMIT = 100;
export const REPORT_GROUP_SUMMARY_MESSAGE_LIMIT_STEP = 5;
export const REPORT_GROUP_SUMMARY_LIMIT_SLIDER_RIGHT_PADDING = 3;

export const REPORT_GROUP_SUMMARY_STORAGE_KEY = 'REPORT_GROUP_SUMMARY_STORAGE';
export const REPORT_GROUP_SUMMARY_CACHE_KEY_SEPARATOR = '::';
export const REPORT_GROUP_SUMMARY_EMPTY_VALUE_PLACEHOLDER = 'NONE';

export const REPORT_GROUP_SUMMARY_TIMEFRAME_ALL = 'ALL';
export const REPORT_GROUP_SUMMARY_TIMEFRAME_LAST_SEVEN_DAYS = 'LAST_SEVEN_DAYS';
export const REPORT_GROUP_SUMMARY_TIMEFRAME_LAST_FOURTEEN_DAYS =
  'LAST_FOURTEEN_DAYS';
export const REPORT_GROUP_SUMMARY_TIMEFRAME_LAST_THIRTY_DAYS =
  'LAST_THIRTY_DAYS';
export const REPORT_GROUP_SUMMARY_TIMEFRAME_CUSTOM = 'CUSTOM';

export const REPORT_GROUP_SUMMARY_DEFAULT_TIMEFRAME =
  REPORT_GROUP_SUMMARY_TIMEFRAME_LAST_SEVEN_DAYS;

export const REPORT_GROUP_SUMMARY_TIMEFRAME_OPTIONS: ReportGroupSummaryTimeframeOption[] =
  [
    {
      value: REPORT_GROUP_SUMMARY_TIMEFRAME_LAST_SEVEN_DAYS,
      translationKey: 'report_group_summary_timeframe_last_seven_days',
      offsetInDays: 7,
    },
    {
      value: REPORT_GROUP_SUMMARY_TIMEFRAME_LAST_FOURTEEN_DAYS,
      translationKey: 'report_group_summary_timeframe_last_fourteen_days',
      offsetInDays: 14,
    },
    {
      value: REPORT_GROUP_SUMMARY_TIMEFRAME_LAST_THIRTY_DAYS,
      translationKey: 'report_group_summary_timeframe_last_thirty_days',
      offsetInDays: 30,
    },
    {
      value: REPORT_GROUP_SUMMARY_TIMEFRAME_CUSTOM,
      translationKey: 'report_group_summary_timeframe_custom',
    },
    {
      value: REPORT_GROUP_SUMMARY_TIMEFRAME_ALL,
      translationKey: 'report_group_summary_timeframe_all',
    },
  ];

export const REPORT_GROUP_SUMMARY_TRANSLATION_KEYS = {
  title: 'report_group_summary_title',
  summaryLabel: 'report_group_summary_summary_label',
  highlightsLabel: 'report_group_summary_highlights',
  blockersLabel: 'report_group_summary_blockers',
  nextStepsLabel: 'report_group_summary_next_steps',
  confidenceLabel: 'report_group_summary_confidence',
  generateButton: 'report_group_summary_generate',
  timeframeLabel: 'report_group_summary_timeframe_label',
  messageLimitLabel: 'report_group_summary_message_limit_label',
  customStartLabel: 'report_group_summary_custom_start_label',
  customEndLabel: 'report_group_summary_custom_end_label',
  emptyState: 'report_group_summary_empty_state',
  lastGenerated: 'report_group_summary_last_generated',
  statusOnTrack: 'report_group_summary_status_on_track',
  statusAtRisk: 'report_group_summary_status_at_risk',
  statusOffTrack: 'report_group_summary_status_off_track',
  confidenceLow: 'report_group_summary_confidence_low',
  confidenceMedium: 'report_group_summary_confidence_medium',
  confidenceHigh: 'report_group_summary_confidence_high',
  highlightsEmpty: 'report_group_summary_highlights_empty',
  blockersEmpty: 'report_group_summary_blockers_empty',
  nextStepsEmpty: 'report_group_summary_next_steps_empty',
  invalidRange: 'report_group_summary_invalid_custom_range',
  generationFailed: 'report_group_summary_generation_failed',
} as const;

export const REPORT_GROUP_SUMMARY_STATUS_TO_TRANSLATION_KEY: Record<
  ReportGroupSummaryStatus,
  string
> = {
  ON_TRACK: REPORT_GROUP_SUMMARY_TRANSLATION_KEYS.statusOnTrack,
  AT_RISK: REPORT_GROUP_SUMMARY_TRANSLATION_KEYS.statusAtRisk,
  OFF_TRACK: REPORT_GROUP_SUMMARY_TRANSLATION_KEYS.statusOffTrack,
};

export const REPORT_GROUP_SUMMARY_STATUS_TO_CHIP_COLOR: Record<
  ReportGroupSummaryStatus,
  ChipProps['color']
> = {
  ON_TRACK: 'success',
  AT_RISK: 'warning',
  OFF_TRACK: 'error',
};

export const REPORT_GROUP_SUMMARY_CONFIDENCE_TO_TRANSLATION_KEY: Record<
  ReportGroupSummaryConfidenceLevel,
  string
> = {
  LOW: REPORT_GROUP_SUMMARY_TRANSLATION_KEYS.confidenceLow,
  MEDIUM: REPORT_GROUP_SUMMARY_TRANSLATION_KEYS.confidenceMedium,
  HIGH: REPORT_GROUP_SUMMARY_TRANSLATION_KEYS.confidenceHigh,
};

export const REPORT_GROUP_SUMMARY_JOB_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETE: 'complete',
  FAILED: 'failed',
} as const;

export const REPORT_GROUP_SUMMARY_JOB_STATUS_POLL_INTERVAL_MS = 5000;
